export const REGISTERE = 'registered/REGISTERE';
export const REGISTERED = 'registered/REGISTERED';
export const FAILURE = 'registered/FAILURE';
export const REGISLOADINGTRUE = 'registered/REGISLOADINGTRUE';
export const REGISLOADINGFALSE = 'registered/REGISLOADINGFALSE';
